import { queryOptions } from "@tanstack/react-query";
import {
  accessOkResponseSchema,
  addDomainResponseSchema,
  credentialsResponseSchema,
  domainsResponseSchema,
  inviteResponseSchema,
  issueCredentialResponseSchema,
  membersResponseSchema,
  type ChangeRoleRequest,
  type InviteRequest,
  type IssueCredentialRequest,
  type UserStateRequest,
} from "../contracts/index";
import { POLL_MS, apiGet, apiPost } from "@amber/ui";
import { accessKeys } from "./keys";

export const membersQuery = queryOptions({
  queryKey: accessKeys.members,
  queryFn: ({ signal }) => apiGet("/api/access/members", membersResponseSchema, signal),
  refetchInterval: POLL_MS,
});

export const domainsQuery = queryOptions({
  queryKey: accessKeys.domains,
  queryFn: ({ signal }) => apiGet("/api/access/domains", domainsResponseSchema, signal),
  refetchInterval: POLL_MS,
});

export const credentialsQuery = queryOptions({
  queryKey: accessKeys.credentials,
  queryFn: ({ signal }) => apiGet("/api/access/credentials", credentialsResponseSchema, signal),
  refetchInterval: POLL_MS,
});

export const accessCommands = {
  invite: (body: InviteRequest, csrf: string | null) =>
    apiPost("/api/access/invitations", body, inviteResponseSchema, csrf),
  revokeInvitation: (id: string, reason: string, csrf: string | null) =>
    apiPost(`/api/access/invitations/${encodeURIComponent(id)}/revoke`, { reason }, accessOkResponseSchema, csrf),
  changeRole: (id: string, body: ChangeRoleRequest, csrf: string | null) =>
    apiPost(`/api/access/users/${encodeURIComponent(id)}/role`, body, accessOkResponseSchema, csrf),
  deactivate: (id: string, body: UserStateRequest, csrf: string | null) =>
    apiPost(`/api/access/users/${encodeURIComponent(id)}/deactivate`, body, accessOkResponseSchema, csrf),
  reactivate: (id: string, body: UserStateRequest, csrf: string | null) =>
    apiPost(`/api/access/users/${encodeURIComponent(id)}/reactivate`, body, accessOkResponseSchema, csrf),
  addDomain: (domain: string, reason: string, csrf: string | null) =>
    apiPost("/api/access/domains", { domain, reason }, addDomainResponseSchema, csrf),
  removeDomain: (id: string, reason: string, csrf: string | null) =>
    apiPost(`/api/access/domains/${encodeURIComponent(id)}/remove`, { reason }, accessOkResponseSchema, csrf),
  issueCredential: (body: IssueCredentialRequest, csrf: string | null) =>
    apiPost("/api/access/credentials", body, issueCredentialResponseSchema, csrf),
  revokeCredential: (id: string, reason: string, csrf: string | null) =>
    apiPost(`/api/access/credentials/${encodeURIComponent(id)}/revoke`, { reason }, accessOkResponseSchema, csrf),
};
